/* eslint-disable no-restricted-syntax */
import axios from "axios";
import { toast } from "react-toastify";
import { EditProjectContextProps } from "../../../EditProjectContext";
import { OdcNetwork } from "../../../../ViewModel/OdcNetwork";
import { addOdcToRoute } from "./AddOdcToRoute";
import { combinedUrls } from "../../../../../URL/functions";
import { projectUrls } from "../../../../../URL/ApplicationUrls";

export async function addOdcInputOnClickHandler(
  input: string,
  ftlRouteId: number,
  EditProjectContext: EditProjectContextProps
) {
  if (!input) {
    throw new Error("OdcOverviewItem GSDB.NetworkType field is required");
  }

  const { project } = EditProjectContext;

  async function addOdcRequest(odcGsdbNetworkType: string) {
    const url = combinedUrls(
      projectUrls.projectFtlRouteApiUrl({
        projectId: project.ProjectId,
        ftlRouteId,
      }),
      `/AddOdc/${odcGsdbNetworkType}`
    );

    const response = await axios.post(url);
    return response.data as OdcNetwork;
  }

  async function addOdcs(input: string) {
    input = input.replaceAll("\t", ".");
    const values = input.trim().split(" ");

    const responses: Array<OdcNetwork> = [];
    for await (const odc of values) {
      if (!odc.includes(".")) {
        throw new Error(
          "Bad Input. One of combination is not in correct format. Please use GSDB.NetworkType"
        );
      }

      const odcForFtlRouteViewModel = await addOdcRequest(odc);

      responses.push(odcForFtlRouteViewModel);
    }
    addOdcToRoute(ftlRouteId, responses, EditProjectContext);
  }

  await toast.promise(addOdcs(input), {
    pending: "Pending",
    error: {
      render({ data }: { data: any }) {
        return data?.message;
      },
    },
    success: `Added following Odc(s): ${input}`,
  });
}
